import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { BasketContact, BasketHasNoContact } from 'components/ordering/acl/internal-types.js'
import { BASKET_API, BasketApi } from 'components/ordering/multiple-baskets/basket-api/basket-api.js'
import {
  AddBasketContactRequest,
  GetBasketContactRequest,
} from 'components/ordering/multiple-baskets/basket-api/basket-contact.js'


const isDefined = <T = any>(value?: T): value is T => value !== undefined
export const ORDERING_STORED_BASKET_CONTACT = Symbol('ORDERING_STORED_BASKET_CONTACT')


@registerDependency(REAL, ORDERING_STORED_BASKET_CONTACT)
@registerDependency(FAKE, ORDERING_STORED_BASKET_CONTACT)
export class OrderingStoredBasketContact implements OrderingStoredBasketContact {
  @inject(BASKET_API)
  private basketApi!: BasketApi

  private _orderingEndpoint?: string
  private get orderingEndpoint(): string {
    if (isDefined(this._orderingEndpoint)) return this._orderingEndpoint
    throw new Error('OrderingStoredBasketContact is not initialized correctly')
  }

  private _basketId?: string
  private get basketId(): string {
    if (isDefined(this._basketId)) return this._basketId
    throw new Error('OrderingStoredBasketContact is not initialized correctly')
  }

  initialize = (orderingEndpoint: string, basketId: string) => {
    this._orderingEndpoint = orderingEndpoint
    this._basketId = basketId
  }

  getBasketContact = (): Promise<BasketContact | BasketHasNoContact> => {
    return this.basketApi.getBasketContact(
      new GetBasketContactRequest(this.orderingEndpoint, this.basketId),
    )
  }

  addBasketContact = async ({ name, telephone }: BasketContact): Promise<void> => {
    await this.basketApi.addBasketContact(
      new AddBasketContactRequest(this.orderingEndpoint, this.basketId, name, telephone),
    )
  }
}
